import { FaFile, FaGithub, FaEnvelope } from 'react-icons/fa6';
import { ProfileObject } from '../../BLL/Profile';
import {NavLink} from 'react-router-dom';
import '../../css/common/hex-style.css';

function HexLinks() {
    return (
    <div className="hex-links">
      <NavLink to="/playground" className={({ isActive }) => isActive ? 'active' : ''}>
        <div className="hex">
          <p className="hex-icon">
            [ Work ]
          </p>
        </div>
      </NavLink>
      <a 
          href="https://theforks.io" 
          target="_blank" 
          rel="noopener noreferrer"
      >  
        <div className="mid hex">
          <p className="theforks">
            [ theForks.io ]
          </p>
        </div>
      </a>
      <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
        <div className="hex">
          <p className="hex-icon">
            [ Inbox ]
          </p>
        </div>
      </NavLink>
    </div>
  );

}
export default HexLinks;